<!-- api loader template (should be converted into shared component) -->
<div class="text-center api-loader d-none" id="api-loader">
  <div>
    <div class="spinner-grow ms-1" role="status"></div>
    <div class="spinner-grow ms-1" role="status"></div>
    <div class="spinner-grow ms-1" role="status"></div>
    @if ($loadId() === 'admin') {
    <p class="mt-2"><em>Please wait while we grab your account contact(s) &amp; role(s)&hellip;</em></p>
    } @if ($loadId() === 'gas-settlement') {
    <p class="mt-2">
      <em> Please wait while we retrieve <br />your settlement statement(s) data...</em>
    </p>
    } @if ($loadId() === 'load-app') {
    <p class="mt-2"><em>Loading dashboard...</em></p>
    } @if ($loadId() === 'load-home') {
    <p><em>Redirecting to dashboard...</em></p>
    } @if ($loadId() === 'mv-meters') {
    <p class="mt-2">
      <em>Please wait while we retrieve your <br />list of operated meters...</em>
    </p>
    } @if ($loadId() === 'mv-single-meter') {
    <p class="mt-2">
      <em
        >Please wait while we retrieve your <br />meter characteristics, gas analysis <br />
        and measured volumes</em
      >
    </p>
    } @if ($loadId() === 'check-detail') {
    <p class="mt-2">Please wait while we load check data associated with your account</p>
    }
  </div>
</div>
